var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallCenterLogoNoBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65039 13.35C10.8428 12.4951 14.1197 8.90228 16.1004 5.25C18.698 7.93513 23.0361 10.5055 27.0666 10.5055C29.6237 10.5055 32.0238 9.83305 34.1004 8.65629",
    stroke: "#B7CCFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8008 28.65C39.3163 28.3813 41.3008 25.2605 41.3008 21.4503C41.3008 17.6396 39.3163 14.5187 36.8008 14.25V28.65Z",
    fill: "#FF8165"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0508 40.3438C22.2933 40.3438 23.3008 41.3512 23.3008 42.5938C23.3008 43.8363 22.2933 44.8438 21.0508 44.8438C19.8082 44.8438 18.8008 43.8363 18.8008 42.5938C18.8008 41.3512 19.8082 40.3438 21.0508 40.3438Z",
    fill: "#A020FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5353 41.7947C27.39 41.3685 30.2821 40.3699 32.2264 38.4221C34.6411 36.0036 36.5227 31.9029 36.5227 28.2351V15.7561C36.5227 12.0883 34.6411 8.36964 32.2264 5.9515C29.812 3.53261 26.0988 1.64844 22.4368 1.64844H20.6095C16.9473 1.64844 13.2346 3.53261 10.8203 5.9515C8.40555 8.36964 6.65039 10.5807 6.65039 14.2484",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98464 28.4714C3.52789 28.206 0.800781 25.1239 0.800781 21.361C0.800781 17.5975 3.52789 14.5154 6.98464 14.25V28.4714Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8008 28.4714C40.2575 28.206 42.9846 25.1239 42.9846 21.361C42.9846 17.5975 40.2575 14.5154 36.8008 14.25V28.4714Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5028 38.7969C23.1697 38.7969 24.5212 40.1505 24.5212 41.8201C24.5212 43.4895 23.1697 44.8432 21.5028 44.8432C19.8359 44.8432 18.4844 43.4895 18.4844 41.8201C18.4844 40.1505 19.8359 38.7969 21.5028 38.7969Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25781 14.5836C10.6822 13.6804 14.4019 10.8353 16.4921 6.97656C19.2335 9.81348 23.0754 11.5783 27.3288 11.5783C30.0274 11.5783 32.5604 10.8678 34.7519 9.62453",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCenterLogoNoBorder);
export default __webpack_public_path__ + "static/media/CallCenterLogoNoBorder.82033e58e9359b5356376e242d1996c5.svg";
export { ForwardRef as ReactComponent };